import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useContext, useMemo } from 'react';

import { TABLET } from '@app/constants/devicesWidth';
import { useNewUserAccessRights, useWindowSize } from '@app/hooks';
import { HeaderContext } from '@app/providers';

import type { FC } from 'react';

import '@pages/Tags/components/TagsPageHeader/styles/TagsPageHeader.scss';

export const TagsPageHeader: FC = () => {
  const { header: state } = useContext(HeaderContext);

  const {
    userAccessRights: { Clients },
  } = useNewUserAccessRights();

  const hasAdditionRight = useMemo(() => Clients?.IsTagsChange, [Clients]);

  const { innerWidth, isMobile } = useWindowSize();

  const label = useMemo(
    () => (innerWidth <= TABLET ? '' : 'Добавить тег'),
    [innerWidth]
  );

  return (
    <div className="TagsPageHeader">
      {hasAdditionRight && (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          className={isMobile ? 'full-width' : ''}
          onClick={() =>
            typeof state.setIsModalOpen === 'function' &&
            state.setIsModalOpen(true)
          }
          data-testid="add-tag"
        >
          {label}
        </Button>
      )}
    </div>
  );
};
